<template>
<div class="custom-offer-selection">
  <section class="custom-offer-selection-info">
    <div>{{template.name}}</div>
    <div>
      <span>{{'admin_startDate' | translate}}</span>
      <span>{{(template.start_date * 1000) | momentFormat('YYYY-MM-DD HH:mm', timezone)}}</span>
    </div>
    <div>
      <span>{{'admin_endDate' | translate}}</span>
      <span>{{(template.end_date * 1000) | momentFormat('YYYY-MM-DD HH:mm', timezone)}}</span>
    </div>
    <div>
      <span>{{'general_selectionContent' | translate}}</span>
      <span>{{template.contentType}}</span>
    </div>
  </section>
  <section class="custom-offer-selection-content-body">
    <template v-for="(item, index) in parseHeaderData">
      <CustomOfferSelecitionData
        v-on:getSelection="getSelection"
        class="body cell"
        :class="[item.name, {'is-last': parseHeaderData.length - 1 === index}]"
        :style="{width: `calc(100% / ${parseHeaderData.length})`}"
        :key="index"
        :data="setDataForSelectionCell(item.name)"
        :name="item.name"
        :translation="item.key"
        :active="temporaryPicked[item.name]"
        :template="template.contentType"/>
    </template>
  </section>
  <section class="custom-offer-selection-content-footer">
    <AdminButton v-on:admin-button="saveChanges"
                 :ab-value="'general_save'"
                 :ab-name="'save'"
                 :ab-style-name="'primary filter'"/>
  </section>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { filter, forEach, findIndex } from 'lodash';
import { momentFormat } from '@/filters';
import CustomOfferSelecitionData from '@/components/CustomOfferSelecitionData';
import AdminButton from '@/components/AdminButton';
import EventBus from '@/store/EventBus';
import { getEdit } from '@/api';
import createHeaders from '@/api/utility';
import updateEdit from '../api/updateEdit';

export default {
  name: 'CustomOfferSelection',
  components: { AdminButton, CustomOfferSelecitionData },
  data() {
    return {
      template: null,
      startTime: null,
      endTime: null,
      headerData: [
        {
          key: 'admin_categories',
          name: 'categories',
        },
        {
          key: 'admin_tournaments',
          name: 'tournaments',
        },
        {
          key: 'admin_markets',
          name: 'markets',
        },
        {
          key: 'admin_events',
          name: 'events',
        },
      ],
      temporaryPicked: {
        categories: null,
        tournaments: null,
        markets: null,
      },
      getSelectionNextMock: {
        categories: 'tournaments',
        tournaments: 'markets',
        markets: 'events',
      },
      categories: [],
      tournaments: [],
      markets: [],
      events: [],
      mock_categories: [
        {
          id: '1039',
          name: 'USA',
          isoCode: 'USA',
          position: 5,
          active: false,
        },
        {
          id: '1040',
          name: 'UK',
          isoCode: 'GBR',
          position: 6,
          active: false,
        },
        {
          id: '1061',
          name: 'Canada',
          isoCode: 'CAN',
          position: 0,
          active: false,
        },
      ],
      mock_tournaments: [
        {
          id: '47115',
          categoryId: '1061',
          name: 'Midday Keno 20/70',
          position: 0,
          active: true,
        },
      ],
      mock_markets: [
        {
          active: true,
          name: 'Draw sum odd/even',
          betType: '821',
          id: '47115_821',
          tournamentId: '47115',
          position: 0,
        },
        {
          active: true,
          name: 'Draw sum total',
          betType: '822',
          id: '47115_822',
          tournamentId: '47115',
          position: 0,
        },
        {
          active: true,
          name: 'Draw sum range',
          betType: '823',
          id: '47115_823',
          tournamentId: '47115',
          position: 0,
        },
        {
          active: true,
          name: 'Standard bet',
          betType: '832',
          id: '47115_832',
          tournamentId: '47115',
          position: 0,
        },
      ],
      mock_events: [
        {
          displayId: '1121',
          id: '47115_832',
          active: true,
          name: 'Midday Keno 20/70',
          position: 0,
          time: '20:00',
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'discoverServerLocation',
      'activeModuleData',
      'selectedRow',
      'language',
      'timezone',
      'user',
    ]),
    parseHeaderData() {
      const type = this.template.contentType;
      return type === 'events'
        ? this.headerData
        : filter(this.headerData, item => item.name !== 'events');
    },
  },
  methods: {
    ...mapActions([
      'setActiveLoader',
      'setNotificationMessage',
      'setCustomOfferSelectionStatus',
    ]),
    /**
     * Check is selection empty
     */
    selectionEmpty(name) {
      // eslint-disable-next-line no-unused-vars
      let valid = false;
      switch (name) {
        case 'categories':
          valid = true;
          break;
        case 'tournaments':
          valid = !!this.temporaryPicked.categories;
          break;
        case 'markets':
          valid = !!this.temporaryPicked.tournaments;
          break;
        case 'events':
          valid = !!this.temporaryPicked.markets;
          break;
        // no default
      }
      return valid;
    },
    /**
     * set data for offer selection
     */
    setDataForSelectionCell(name) {
      // eslint-disable-next-line no-unused-vars
      let data = null;
      switch (name) {
        case 'categories':
          data = this.categories;
          break;
        case 'tournaments':
          data = filter(this.tournaments,
            tournament => tournament.categoryId === this.temporaryPicked.categories);
          break;
        case 'markets':
          data = filter(this.markets,
            market => market.id.split('_')[0] === this.temporaryPicked.tournaments);
          break;
        case 'events':
          data = filter(this.events,
            event => event.id === this.temporaryPicked.markets);
          break;
        // no default
      }
      return data;
    },
    /**
     * Fetch data for some selections
     *
     * Here we will fetch some selection data
     * (only at mount component we will fetch categories by default)
     */
    async fetchData(type, data = null, isParentChecked = false) {
      this.setActiveLoader(true);
      try {
        const headers = createHeaders(this.discoverServerLocation, this.user);
        let url = '';
        switch (type) {
          case 'categories':
            url = `${this.discoverServerLocation.productApi.url}${process.env.VUE_APP_OFFER_CATEGORIES}?offerId=${this.template.id}&timezone=${this.timezone}`;
            break;
          case 'tournaments':
            url = `${this.discoverServerLocation.productApi.url}${process.env.VUE_APP_OFFER_CATEGORIES}/${data.id}/tournaments?offerId=${this.template.id}&timezone=${this.timezone}&isChecked=${isParentChecked}`;
            break;
          case 'markets':
            url = `${this.discoverServerLocation.productApi.url}${process.env.VUE_APP_OFFER_TOURNAMENTS}${data.id}/markets?offerId=${this.template.id}&timezone=${this.timezone}&isChecked=${isParentChecked}`;
            break;
          case 'events':
            url = `${this.discoverServerLocation.productApi.url}${process.env.VUE_APP_OFFER_EVENTS}${this.temporaryPicked.tournaments}/${this.temporaryPicked.markets.split('_')[1]}?offerId=${this.template.id}&timezone=${this.timezone}&isChecked=${isParentChecked}`;
            break;
            // no default
        }
        const response = await getEdit(url, headers);
        if (response.status === 200 && response.data.length) {
          const mergeData = [...this[type], ...response.data];
          this.$set(this, type, mergeData);
        }
      } finally {
        this.setActiveLoader(false);
      }
    },
    getSelection(event) {
      const isParentChecked = event.data.active;
      if (event.data && event.data.id !== this.temporaryPicked[event.name]) {
        switch (event.name) {
          case 'categories':
            this.$set(this.temporaryPicked, 'tournaments', null);
            this.$set(this.temporaryPicked, 'markets', null);
            this.$set(this.temporaryPicked, 'events', null);
            break;
          case 'tournaments':
            this.$set(this.temporaryPicked, 'markets', null);
            this.$set(this.temporaryPicked, 'events', null);
            break;
          case 'markets':
            this.$set(this.temporaryPicked, 'events', null);
            break;
          // no default
        }
      }
      this.$set(this.temporaryPicked, event.name, event.data.id);
      const selectionName = this.getSelectionNextMock[event.name];
      const filterSelectionsMock = {
        categories: 'categoryId',
        tournaments: 'tournamentId',
        markets: 'id',
      };
      const data = this[selectionName];
      const haveSelection = filter(data,
        item => item[filterSelectionsMock[event.name]]
          === event.data.id).length > 0;
      if (haveSelection) {
        this.$set(this.temporaryPicked, event.name, event.data.id);
      } else {
        this.fetchData(selectionName, event.data, isParentChecked);
      }
    },
    saveChanges() {
      let data = null;
      const categoriesMapper = {
        tournaments: null,
        markets: null,
      };
      if (this.template.contentType === 'events') {
        categoriesMapper.events = null;
      }
      const categories = filter(this.categories, item => item.active);
      if (categories.length) {
        data = categories;
        forEach(categories, (category, index) => {
          const tournaments = filter(this.tournaments,
            item => item.categoryId === category.id && item.active);
          if (tournaments.length) {
            data[index].tournaments = tournaments;
            forEach(tournaments, (tournament, indexTournament) => {
              const markets = filter(this.markets,
                item => item.tournamentId === tournament.id && item.active);
              if (markets.length) {
                data[index].tournaments[indexTournament].markets = markets;
                forEach(markets, (market, indexMarket) => {
                  const events = filter(this.events,
                    item => item.id === market.id && item.active);
                  if (events.length) {
                    data[index].tournaments[indexTournament].markets[indexMarket].events = events;
                  }
                });
              }
            });
          }
        });
        const headers = createHeaders(this.discoverServerLocation, this.user);
        const url = `${this.discoverServerLocation.productApi.url}${process.env.VUE_APP_SAVE_PRINT_OFFER_SELECTIONS}/NumbersBetting?offerId=${this.template.id}&timezone=${this.timezone}`;
        updateEdit(url, data, headers).then(() => {
          this.setNotificationMessage({
            title: 'general_success',
            description: 'admin_changesSavedSuccessfully',
            rulesActions: false,
          });
          this.setCustomOfferSelectionStatus(false);
        });
      }
    },
    selectionCheck(cell) {
      const mapperUp = {
        tournaments: ['categories'],
        markets: ['categories', 'tournaments'],
        events: ['categories', 'tournaments', 'markets'],
      };

      const mapperDown = {
        categories: ['tournaments', 'markets', 'events'],
        tournaments: ['markets', 'events'],
        markets: ['events'],
        events: ['events'],
      };
      const mapper = cell.direction === 'up' ? mapperUp : mapperDown;
      if (cell.direction === 'up'
        && cell.data.id === this.temporaryPicked[cell.name]
        && cell.name !== 'events') {
        forEach(mapperDown[cell.name], (event) => {
          // eslint-disable-next-line no-param-reassign
          const data = filter(this[event],
            item => item.id
              === (event !== 'events' ? this.temporaryPicked[event] : item.id));
          forEach(data, (item, index) => {
            data[index].active = true;
          });
        });
      }
      forEach(mapper[cell.name], (name) => {
        if (this[name].length) {
          const indexValue = findIndex(this[name], item => item.id
            === (name !== 'events' ? this.temporaryPicked[name] : cell.data.id));
          if (indexValue >= 0) {
            this[name][indexValue].active = cell.direction === 'up';
          }
        }
      });
    },
    async fetchCategories() {
      this.setActiveLoader(true);
      try {
        const headers = createHeaders(this.discoverServerLocation, this.user);
        const url = `${this.discoverServerLocation.productApi.url}${process.env.VUE_APP_OFFER_CATEGORIES}?offerId=3&timezone=${this.timezone}`;
        const data = await getEdit(url, headers);
        if (data.status === 200 && data.data.length) {
          this.$set(this, 'categories', data.data);
        }
      } finally {
        this.setActiveLoader(false);
      }
    },
  },
  async created() {
    this.template = this.activeModuleData.data[this.selectedRow];
    this.template.contentType = 'events';
    this.startTime = momentFormat(this.template.start_date * 1000, 'YYYY-MM-DD*HH:mm:00');
    this.endTime = momentFormat((this.template.start_date * 1000) + 50000000, 'YYYY-MM-DD*HH:mm:59');
    await this.fetchData('categories');
    EventBus.$on('activateTemporarySelection', (cell) => {
      this.selectionCheck(cell);
    });
  },
};
</script>

<style lang="scss" scoped>
  .custom-offer-selection {
    background-color: #fff;
    bottom: 0;
    font-size: 12px;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 999;
    .custom-offer-selection-info {
      align-items: center;
      display: flex;
      font-family: primary-font-bold;
      font-size: 14px;
      height: 55px;
      padding: 0 10px;
      > div {
        padding-right: 10px;
        &:first-child {
          padding-left: 10px;
        }
        &:not(:last-child):after {
          content: '|';
          padding-left: 10px;
        }
        > span {
          &:first-child:after {
            content: ':';
            padding-left: 2px;
            padding-right: 5px;
          }
          &:last-child {
            font-family: primary-font;
          }
        }
      }
    }
    .custom-offer-selection-content-header {
      align-items: center;
      background: #7E8B9E;
      color: #fff;
      height: 30px;
      .header {
        padding: 0 10px;
        &:not(:last-child) {
          border-right: 1px solid #fff;
        }
      }
      .cell-name {
        text-transform: capitalize;
      }
    }
    .custom-offer-selection-content-body {
      display: flex;
      height: calc(100% - 110px);
    }
    .body {
      border-bottom: 1px solid #DEE3E5;

      &:not(.events) {
        border-right: 1px solid #DEE3E5;
      }
    }
    .cell {
      align-items: center;
      display: flex;
      > div {
        padding-left: 10px;
      }
    }
    .custom-offer-selection-content-footer {
      align-items: center;
      display: flex;
      height: 55px;
      justify-content: flex-end;
      padding-right: 20px;
    }
  }
</style>
